import * as React from 'react';
import { useState } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { useNavigate } from "react-router-dom";

import CallIcon from '@mui/icons-material/Call';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';


import logo_long from './assets/logo_New.png';
import lotus from './assets/lotus.png';
import './Home.css';
import './Tarif.css';


export default function Home() {
    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const navigate = useNavigate();

    return (
        <div class="main">
            <div class="head">
                <div class='logo'>
                    <img alt="sample" src={logo_long} width="100%" />
                </div>
                <div class="nav">
                    <Tabs value={value} variant="scrollable" allowScrollButtonsMobile="true" onChange={handleChange}>
                        <Tab onClick={() => navigate("/")} label="Présentation" />
                        <Tab onClick={() => navigate("/Symptomes")} label="Les Prestations" />
                        <Tab onClick={() => navigate("/Soins")} label="Déroulement Séance" />
                        <Tab onClick={() => navigate("/Guidance")} label="Guidance" />
                        <Tab value={0} onClick={() => navigate("/Tarifs")} label="Tarifs" />
                        <Tab onClick={() => navigate("/Mentions")} label="Mentions légales" />
                    </Tabs>
                </div>
            </div>
            <div class="bloc-rose">
                <img src={lotus}  alt="image" />
            </div>
            <div class="body">
                <div class="row">
                    <div class="cartes">
                        <div class="card carte6">
                            <h3>Magnétisme</h3>
                            <h4 class="price">40 €</h4>
                            <p class="description">Verrue, eczema, zona, brûlure, démangeaison, ...</p>
                        </div>

                        <div class="card carte4">
                            <h3>Soins de lumière énergétique</h3>
                            <h4 class="price">Adulte : 65 €</h4>
                            <h4 class="price">Enfant (- 10 ans) : 45 €</h4>
                            <h4 class="price">Animaux : 45 €</h4>
                            <p class="description">Libération émotionnelle, ancrage, harmonisation et équilibrage des corps</p>
                        </div>

                        <div class="card carte2">
                            <h3>Soins du triangle Doré - Soins féminin Sacré Isis</h3>
                            <h4 class="price">1h : 65 €</h4>
                        </div>

                        <div class="card carte3">
                            <h3>Guidance</h3>
                            <h4 class="price">Cartomancie : 65 €</h4>
                            <h4 class="price">Boule divinatoire : 65 €</h4>
                            <h4 class="price">30min : 40 €</h4>
                        </div>

                        <div class="card carte11">
                            <h3>Boule de divination</h3>
                            <h4 class="price">45min : 70€</h4>
                        </div>

                        <div class="card carte5">
                            <h3>Libération karmique et transgénérationnel</h3>
                            <h4 class="price">65 €</h4>
                            <p class="description">Ces libérations karmiques permettent de débloquer une situation que vous vivez actuellement.</p>
                            <p class="description">Ces libérations apportent un alignement avec soi-même et un nouvel équilibre dans tous les corps.</p>
                        </div>

                        <div class="card carte7">
                            <h3>Lecture d'âme akashique</h3>
                            <h4 class="price">70 €</h4>
                        </div>

                        <div class="card carte8">
                            <h3>Nettoyage et harmonisation maison</h3>
                            <h4 class="price">50 €</h4>
                        </div>

                        <div class="card carte9">
                            <h3>Enseignement</h3>
                            <h4 class="price">200 € / module</h4>
                            <p class="price">Module 1 : Initiation magnétisme</p>
                            <p class="price">Module 2 : Soin et magnétisme à distance</p>
                            <h4 class="price">Communiquer avec ses guides de lumière : 140 €</h4>
                            <h4 class="price">Soin Isis transmission : 180 €</h4>
                        </div>

                        <div class="card full-width carte10">
                            <h3>Autre</h3>
                            <p class="price">Consultation : lundi, mardi, jeudi, vendredi</p>
                            <p class="price">horaires : 9h00, 10h30, 12h00, 13h15, 14h30</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bloc-info column">
                <p>Séance entre 45 min et 1h. Au-delà, le flux sera coupé.</p>
                <p> Je ne réponds pas au SMS après séance. </p>
                <p>Si vous avez des questionnements complémentaires, un autre rendez-vous sera alors necessaire.</p>
                <p>Merci de votre compréhension</p>
            </div>
            <div class="footer">
                <h1 class='font-flashback'>Contactez-moi</h1>
                <div class='info'>
                <h3 class="row"><LocationOnIcon /> <div class="column"><div>Rue des Perrières</div>  <div>41120 Les Montils</div></div></h3>
                <a href="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d673.8003892953336!2d1.2964262696721434!3d47.505465804141785!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e355c6aac2898d%3A0xc6f15df79f0358e4!2sRue%20des%20Perri%C3%A8res%2C%2041120%20Les%20Montils!5e0!3m2!1sfr!2sfr!4v1775668708443!5m2!1sfr!2sfr" target="_blank">
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d673.8003892953336!2d1.2964262696721434!3d47.505465804141785!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e355c6aac2898d%3A0xc6f15df79f0358e4!2sRue%20des%20Perri%C3%A8res%2C%2041120%20Les%20Montils!5e0!3m2!1sfr!2sfr!4v1775668708443!5m2!1sfr!2sfr" 
                    width="100%" 
                    height="50%" ></iframe>
                </a>
                <h3><CallIcon /> 07 65 81 58 40</h3>
                    <h3><MailOutlineIcon /> Soinsenergetiques41@gmail.com</h3>
                </div>
                <div class='info'>
                    <h3><FacebookIcon /><a rel="noreferrer" target="_blank" href="https://www.facebook.com/soinsenergetiques41" underline="none">soinsenergetiques41</a></h3>
                    <h3><InstagramIcon /><a rel="noreferrer" target="_blank" href="https://www.instagram.com/cynthia_energeticienne_spirite/" underline="none">cynthia_energeticienne_spirite</a></h3>
                    <h3><a rel="noreferrer" target="_blank" href="https://www.resalib.fr/praticien/63425-cynthia-beaumenil-energeticien-les-montils" underline="none">RESALIB</a></h3>
                </div>
            </div>
        </div>
    )
}
